import { Component, HostListener, Input } from '@angular/core';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';

/**
 * "Back to top" control for long pages such as the booking form.
 *
 * The button only appears once the user has scrolled far enough for it to be
 * useful. Activating it scrolls the window to the top and moves focus to the
 * page heading, so keyboard and screen reader users are taken back to the top
 * of the page rather than just having the view scrolled underneath them.
 */
@Component({
  selector: 'app-back-to-top',
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.scss'],
})
export class BackToTopComponent {
  /** Distance in pixels the user must scroll before the button is shown. */
  @Input() showAfter = 300;

  faChevronUp = faChevronUp;
  visible = false;

  @HostListener('window:scroll')
  onWindowScroll() {
    this.visible = window.pageYOffset > this.showAfter;
  }

  backToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const heading = document.querySelector('h1');
    if (heading) {
      // h1 is not focusable by default, so make it programmatically focusable.
      heading.setAttribute('tabindex', '-1');
      (heading as HTMLElement).focus({ preventScroll: true });
    }
  }
}
